<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]" *ngIf="isOpen">
    <div class="bg-white rounded-2xl p-[30px] w-full max-w-xl relative">
        <button
            class="w-[37px] h-[37px] text-[#000000cc] flex items-center justify-center absolute -top-3 -right-3 bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
            (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <ng-container *ngIf="operation == 'tfa_auth'">
            <div class="flex flex-col gap-8 text-center">

                <!-- Lock Icon -->
                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Enter authenticator code
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        Please enter the 6-digit code from authenticator app.
                    </p>
                </div>
                <div class="flex justify-center w-full">
                    <ng-otp-input [config]="otpConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
                </div>

                <!-- Next -->
                <!-- <button (click)="verifyMFACode()"
                    class="text-sm font-syne bg-black text-white py-3.5 rounded-xl font-semibold border border-transparent hover:text-black hover:bg-secondary-button-black hover:border-secondary-button-black duration-200 ease-in-out cursor-pointer">
                    Verify TFA
                </button> -->

                <p class="text-black font-semibold text-lg cursor-pointer" (click)="openRecoveryModal()">I Lost My
                    Device</p>

            </div>
        </ng-container>

        <!-- Recovery-Modal -->
        <ng-container *ngIf="isOpenRecoveryModalShow">
            <div class="flex flex-col gap-8 text-center relative">
                <button (click)="closeRecoveryModal()"
                    class="flex items-center justify-center absolute left-0 top-0 w-[37px] h-[37px] text-secondary-text-black bg-light-black-100 rounded-full hover:text-white hover:bg-black duration-200 ease-in-out cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M3.46875 9.50146H16.0015" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M8.57006 15.0714C8.57006 15.0714 3.00001 10.969 3 9.50123C2.99999 8.03341 8.57015 3.93115 8.57015 3.93115"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>

                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Enter Recovery code
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        To log in enter your recovery code you saved while 2FA .
                    </p>
                </div>
                <div class="flex justify-center w-full">
                    <ng-otp-input [config]="recoveryConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
                </div>

                <div class="flex flex-col gap-5">
                    <button
                        class="flex items-center justify-center gap-2.5 text-base font-syne bg-secondary-button-black text-secondary-text-black px-5 rounded-xl font-semibold cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 16V11.5" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 8.01195V8.00195" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Two-Factor Authentication will be disabled.
                    </button>
                </div>
            </div>
        </ng-container>

        <!-- Contact-Blockchain-Modal -->
        <!-- <ng-container>
            <div class="flex flex-col gap-8 text-center relative">
                <button class="flex items-center justify-center absolute left-0 top-0 w-[37px] h-[37px] text-secondary-text-black bg-light-black-100 rounded-full hover:text-white hover:bg-black duration-200 ease-in-out cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M3.46875 9.50146H16.0015" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.57006 15.0714C8.57006 15.0714 3.00001 10.969 3 9.50123C2.99999 8.03341 8.57015 3.93115 8.57015 3.93115" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>

                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Contact BlockchainX Support
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        For help recovering your account, please contact the Polymarket support team.
                    </p>
                </div>
            </div>
        </ng-container> -->

        <ng-container *ngIf="showDisableTFAStatus">
            <div class="flex flex-col gap-6 text-center">
                <div
                    class="flex items-center justify-center w-[70px] h-[70px] mx-auto rounded-full bg-primary-text-green">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <path
                            d="M8.75 25.375C8.75 25.375 11.375 25.375 14.875 31.5C14.875 31.5 24.6029 15.4583 33.25 12.25"
                            stroke="white" stroke-width="2.625" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="text-center">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Two-factor authentication Disabled
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        You have successfully disabled two-factor authentication
                    </p>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="operation == 'login'">

            <h2 class="text-black text-2xl font-bold mb-2">Welcome to Prediction Market</h2>
            <!-- <p class="text-base text-[#00000099] font-medium">Already have an account? <a href="#"
                class="text-black font-semibold">Login</a></p> -->

            <button
                class=" flex items-center justify-center gap-2.5 text-base font-syne font-semibold w-full bg-black text-white border border-transparent hover:text-black hover:bg-white hover:border hover:border-black duration-300 ease-in-out p-3 rounded-xl cursor-pointer my-6"
                (click)="loginAction('social_login', 'web2', 'google')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_4647_39677)">
                        <path
                            d="M4.43242 12.0863L3.73625 14.6852L1.19176 14.739C0.431328 13.3286 0 11.7149 0 10C0 8.34179 0.403281 6.77804 1.11813 5.40112H1.11867L3.38398 5.81644L4.37633 8.06815C4.16863 8.67366 4.05543 9.32366 4.05543 10C4.05551 10.7341 4.18848 11.4374 4.43242 12.0863Z"
                            fill="currentColor" />
                        <path
                            d="M19.8252 8.13184C19.94 8.73676 19.9999 9.36148 19.9999 9.99996C19.9999 10.7159 19.9246 11.4143 19.7812 12.0879C19.2944 14.3802 18.0224 16.3818 16.2604 17.7983L16.2598 17.7978L13.4065 17.6522L13.0027 15.1313C14.1719 14.4456 15.0857 13.3725 15.567 12.0879H10.2197V8.13184H15.645H19.8252Z"
                            fill="currentColor" />
                        <path
                            d="M16.26 17.7978L16.2606 17.7984C14.5469 19.1758 12.3699 20 10.0001 20C6.19189 20 2.88092 17.8715 1.19189 14.739L4.43256 12.0863C5.27705 14.3401 7.45123 15.9445 10.0001 15.9445C11.0957 15.9445 12.1221 15.6484 13.0029 15.1313L16.26 17.7978Z"
                            fill="currentColor" />
                        <path
                            d="M16.383 2.30219L13.1434 4.95438C12.2319 4.38461 11.1544 4.05547 10 4.05547C7.39344 4.05547 5.17859 5.73348 4.37641 8.06813L1.11871 5.40109H1.11816C2.78246 2.19231 6.1352 0 10 0C12.4264 0 14.6511 0.864297 16.383 2.30219Z"
                            fill="currentColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0_4647_39677">
                            <rect width="20" height="20" fill="currentColor" />
                        </clipPath>
                    </defs>
                </svg>
                Continue With Google
            </button>

            <div class="flex items-center gap-3 mb-6">
                <span class="flex-1 h-px bg-secondary-button-black"></span>
                <span class="text-base font-syne font-medium text-secondary-text-black">OR</span>
                <span class="flex-1 h-px bg-secondary-button-black"></span>
            </div>

            <div class="relative mb-5" [formGroup]="loginForm">
                <input type="email" placeholder="Enter Email" formControlName="email" class="w-full text-base font-normal placeholder:text-[#00000059]
           border border-secondary-button-black rounded-lg
           p-[18px] pr-[140px]"
                    [ngClass]="{'border-red-500': loginForm.get('email')?.invalid && loginForm.get('email')?.touched}" />

                <button (click)="loginAction('email_link', 'web2')" [disabled]="loginForm.invalid" class="absolute top-2 right-2 rounded-md py-2.5 px-6 font-semibold font-syne cursor-pointer
           text-white bg-black
           transition-all duration-300 ease-in-out
           disabled:opacity-20 disabled:cursor-not-allowed 
           disabled:pointer-events-none">
                    Continue
                </button>
                <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    class="text-red-500 text-xs mt-1 absolute -bottom-5 left-0">
                    <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
                    <span *ngIf="loginForm.get('email')?.errors?.['email'] 
    || loginForm.get('email')?.errors?.['pattern']">
                        Please enter a valid email address
                    </span>
                </div>
            </div>

            <ul class="flex justify-between gap-5">
                <li class="w-full block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3', 'metaMask')"
                        class="w-full h-[60px] flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img src="assets/icons/login-image1.svg">
                    </a>
                </li>
                <li class="w-full block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3', 'walletConnect')"
                        class="w-full h-[60px] flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img src="assets/icons/login-image2.svg">
                    </a>
                </li>
                <li class="w-full block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3')"
                        class="w-full h-[60px] flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img src="assets/icons/login-image3.svg">
                    </a>
                </li>
                <li class="w-full block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3')"
                        class="w-full h-[60px] flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img src="assets/icons/login-image4.svg">
                    </a>
                </li>
            </ul>

        </ng-container>
    </div>
</div>